// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_G9SKp","deal-discount-tag":"deal-discount-tag_xCjIJ","value":"value_5dqfZ"};